import { TenantListDTO } from '../tenant/tenant-list.dto';

export class AbilityPricelistDTO {

   id: string;

   name: string;

   description: string;

   currency: string;

   defaultForCurrency: boolean;

   monthly: number;

   yearly: number;

   appNotifications: number;

   emailNotifications: number;

   smsNotifications: number;

   storage: number;

   phoneSupport: number;

   createdBy: string;

   updatedBy: string;

   createdAt: Date;

   updatedAt: Date;

   tenants: Array<TenantListDTO>;

}
